module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?> <svg width=15px height=15px viewBox=\"0 0 15 15\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <polygon fill-rule=nonzero points=\"12.35 14.07 14.254 12.166 9.447 7.359 14.254 2.552 12.35 0.648 7.543 5.455 2.705 0.617 0.801 2.521 5.639 7.359 0.801 12.197 2.705 14.101 7.543 9.263\"></polygon> </svg>";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/x.svg
// module id = 300
// module chunks = 0